import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useSearchStore = create()(
  // persist(
    (set) => ({
      searchPageSearchParams: null,

      setSearchPageSearchParams: (params) =>
        set({ searchPageSearchParams: params }),

      reset: () =>
        set({
          searchPageSearchParams: null,
        }),
    }),
    {
      name: "search-storage", // unique name for localStorage
      // partialize: (state) => ({
      //   searchPageSearchParams: state.searchPageSearchParams,
      // }),
    }
  // )
);
